<template lang="pug">
//- #tpx-basket-bar.row.justify-content-between.align-items-center.tpx.mx-0.py-0.border-bottom-0.topNavBox
div.align-items-center.tpx.mx-0.py-0.border-bottom-0.topNavBox(id="tpx-basket-bar")
  //- mobile menu
  .d-flex.justify-content-between.align-items-center.border-bottom-0.mobile
    label.hamburger(for="hamburger" @click="sideBarShowEvent(true)") <i class="fas fa-bars"></i>
    router-link.logoBox(to="/")
      img(:src="imgLogo")
    //- 登入/註冊Taopix按鈕
    label.item.register.mb-0.align-items-center.mobile
      a.font-weight-bold.text-decoration-none.mobile(id="tpx-signIn2" onclick="tpxHighLevelRegisterInitControl(); return false;")
    //- 編輯中的作品
    //- label.item.myItem.mb-0.align-items-center.mobile(id="tpx-projectslinkli2")
    //-   a.text-dark.text-decoration-none.mobile(id="tpx-projectslist2" href="#" onclick="tpxMyProjectsOnClick(); return false;")
    //- 2022/09/05, jamei
    //- 編輯中的作品
    label.item.myItem.editingItem.mb-0.align-items-center.tpx.tpx-accountLinkItem.mobile(id="tpx-projectslinkli2")
      span.mobile(id="tpx-projectslist2" onclick="tpxMyProjectsOnClick(); return false;")
    //- 購物車
    div.item.myItem.mb-0.align-items-center.tpx.mobile.cart
      .tpx.mobile(id="tpx-basketButtonWrapper2")
        p.mb-0.tpx.tpx-button.tpx-basketButton.mobile(id="tpx-basketlink2" onclick="tpxBasketOnClick(); return false;")
          span.tpx.tpx-basketCount2(id="tpx-basketButtonCount2")

  //- 大於 640 秀的畫面
  .darkBg(v-if="sideBarShow" @click="sideBarShowEvent(false)" @touchmove.prevent="")
  div.tpx.tpx-bar-container.tpx-clearfix.topNav(id="tpx-basket-bar-inner" :class="{'show' : sideBarShow}")
    //- div.xBox(@click="sideBarShowEvent(false)")
    //-   i.fas.fa-times
    .sideNavHead.d-flex.justify-content-between
      .logo
        router-link(to="/")
          img(:src="imgLogo").img-fluid
      .closeTag(@click="sideBarShowEvent(false)").d-md-none <i class="fa-solid fa-xmark"></i>
    //- desk top 所有產品
    div.item.allProd.mb-0.align-items-center.deskTop.activity(v-if="activityOpen") 主題專區
      .styleDropDownMenu.bg-white.px-3
        .text-decoration-none.row
          .col-12.py-3(v-for="(item,idx) in totalActivityCategory")
            .d-flex.flex-column
              //- p.text-decoration-none.mb-2.itemHover {{item}}
              router-link.text-decoration-none.pl-3.mb-2.itemHover(v-for="item1 in totalActivity" :key="item1.id" :to="'/activity/' + item1.id") {{item1.activityName}}
    div.item.allProd.mb-0.justify-content-between.align-items-center.deskTop(v-for="(item1, idx1) in navBarList1")
      img(:src="item1.icon_file" v-if="item1.icon_file !== null && item1.icon_file !== ''").newItem
      span(@click.prevent="productdetail(item1.link_category_id)") {{item1.label}}
      .dropDownMenu.py-3.bg-white.px-1.text-decoration-none
        .d-flex.flex-nowrap.row-cols-auto
          .col.navbarItem.justify-content-center(v-for="(item2, idx2) in navBarList2" v-if="item2.parent_id === item1.id")
            .itemTitle.d-flex.justify-content-start
              span(@click.prevent="productdetail(item2.link_category_id)" v-if="item2.label !== ''").categoryCaption.font-weight-bold.text-center.text-decoration-none.mb-2.pt-2.text-align-center {{item2.label}}
            div.d-flex.flex-column.text-decoration-none.mb-2.itemHover(v-for="(item3, idx3) in navBarList3" v-if="item3.parent_id === item2.id" @click.prevent="goProductPage(item3.link_productId, item3.href_target)")
              span {{ item3.label }}
                img(:src="item3.icon_file" v-if="item3.icon_file !== null && item3.icon_file !== ''").newItem
    //- 2022/08/31, jamei
    //- div.item.allProd.mb-0.justify-content-between.align-items-center.deskTop(v-if="shop2Open") 稿件上傳製作
      .dropDownMenu.bg-white.px-3.text-decoration-none.row
        .row.row-cols-auto
          .col.py-3(v-for="(item,idx) in totalCategory")
            .d-flex.flex-column
                p.text-center.text-decoration-none.mb-2.itemHover2(v-for="item1 in totalProduct" v-if="item1.productCategory === item" :key="item1.productId" @click.prevent="goProductPage(item1.productId, item1.url, YFP_SHOP)") {{item1.productName}}

    div.item.allProd.mb-0.align-items-center.deskTop(v-if="styleOpen") 設計/品牌合作
      .styleDropDownMenu.bg-white.px-3
        .text-decoration-none.row
          .col-12.py-3(v-for="(item,idx) in totalDesignCategory")
            .d-flex.flex-column
              router-link.corpCaption.text-decoration-none.pl-3.mb-2.itemHover(v-for="item1 in totalCorp"  :key="item1.designerId" :to="'/designer/' + item1.id + '/' + item1.designerId") {{item1.designerName}}
              router-link.text-decoration-none.pl-3.mb-2.itemHover(v-for="item1 in totalDesign" v-if="item1.groupcode === item" :key="item1.designerId" :to="'/shop2/designer/' + item1.id + '/' + item1.designerId") {{item1.designerName}}
              //- 2022/10/26, jamei, p.corpCaption.text-decoration-none.pl-3.mb-2.itemHover(v-for="item1 in totalCorp"  :key="item1.designerId" @click.prevent="goDesignerPage(item1.id, item1.designerId, YFP_SHOP)") {{item1.designerName}}
    //- div.item.allProd.mb-0.align-items-center.deskTop(v-if="publicwelfareOpen") 公益專區
      .styleDropDownMenu.bg-white.px-3
        .text-decoration-none.row
          .col-12.py-3(v-for="(item,idx) in totalPublicWelfareCategory")
            .d-flex.flex-column
              //- p.text-decoration-none.mb-2.itemHover {{item}}
              router-link.text-decoration-none.pl-3.mb-2.itemHover(v-for="item1 in totalPublicWelfare" v-if="item1.groupcode === item" :key="item1.productId" :to="'/shop2/designer/' + item1.id + '/' + item1.designerId") {{item1.designerName}}

    //- mobile 所有產品
    .sidebarBox.w-100
      .sidebar.d-flex.flex-column.pt-3
        .hr
        router-link(to="/").item.text-decoration-none.text-dark.font-weight-bold.indexpage 首頁
        .navMobileItem.navItem(v-for="(item1, idx1) in navBarList1")
          <input type="checkbox" :id="idx1" class="d-none navMobileDetailItem">
          .font-weight-bold.align-items-center.pt-1.mb-0.d-flex
            img(:src="item1.icon_file" v-if="item1.icon_file !== null && item1.icon_file !== ''").newItem
            span(@click="productdetail(item1.link_category_id)") {{item1.label}}
          label(:for="idx1").d-flex.justify-content-end <i class="fas fa-chevron-down ml-auto"></i><i class="fas fa-chevron-up ml-auto"></i>
          .allProdItemBox
            .navbarListItem.mt-2.font-weight-bold.allProdItem(v-for="(item2, idx2) in navBarList2" v-if="item2.parent_id === item1.id && item2.label !== ''")
              input.allProdItemDetail.d-none(type="checkbox" :id="item2.id")
              label.d-flex(:for="item2.id").mb-0
                p(@click.prevent="productdetail(item2.link_category_id)") {{item2.label}}
                <i class="fas fa-chevron-down ml-auto"></i>
                <i class="fas fa-chevron-up ml-auto"></i>
              p.mb-0.font-weight-bold.pl-3.py-2.allProdItemDetailItem.fz14.text-decoration-none(v-for="(item3, idx3) in navBarList3" v-if="item3.parent_id === item2.id" @click.prevent="goProductPage(item3.link_productId, item3.href_target)")
                span - {{ item3.label }}
                  img(:src="item3.icon_file" v-if="item3.icon_file !== null && item3.icon_file !== ''").newItem
            .navbarListItem.mt-2.font-weight-bold.allProdItem(v-for="(item2, idx2) in navBarList2" v-if="item2.parent_id === item1.id && item2.label === ''")
              p.mb-0.font-weight-bold.pl-3.py-2.fz14.text-decoration-none(v-for="(item3, idx3) in navBarList3" v-if="item3.parent_id === item2.id" @click.prevent="goProductPage(item3.link_productId, item3.href_target)")
                span - {{ item3.label }}
                  img(:src="item3.icon_file" v-if="item3.icon_file !== null && item3.icon_file !== ''").newItem
        //- 設計/品牌合作
        <input type="checkbox" id="designer" class="d-none">
        label(for="designer").navItem.font-weight-bold.align-items-center.mb-0.d-flex.justify-content-between 設計/品牌合作
          .d-flex.mt-4.navBarList1Chevron <i class="fas fa-chevron-down ml-auto"></i><i class="fas fa-chevron-up ml-auto"></i>
        .allProdItemBoxDesigner.w-100
          .navItem.font-weight-bold.allProdItem( v-for="(item,idx) in totalCorpCategory" )
            .flex-column.allProdItemDetailItem
              span.text-decoration-none.pl-3.mb-2.itemHover(v-for="item1 in totalCorp" v-if="item1.groupcode === item" :key="item1.designerId" :to="'/designer/' + item1.id + '/' + item1.designerId" @click="designer(item1.id,item1.designerId)") - {{item1.designerName}}
          .navItem.font-weight-bold.allProdItem( v-for="(item,idx) in totalDesignCategory" )
            .flex-column.allProdItemDetailItem
              span.text-decoration-none.pl-3.mb-2.itemHover(v-for="item1 in totalDesign" v-if="item1.groupcode === item" :key="item1.productId" :to="'/designer/' + item1.id + '/' + item1.designerId" @click="designer(item1.id,item1.designerId)") - {{item1.designerName}}
        //- <input type="checkbox" id="corp" class="d-none">
        //- label(for="corp").navItem.font-weight-bold.align-items-center.mb-0.d-flex 品牌合作<i class="fas fa-chevron-down ml-auto"></i><i class="fas fa-chevron-up ml-auto"></i>
        .allProdItemBoxDesigner.w-100
          .navItem.font-weight-bold.allProdItem( v-for="(item,idx) in totalCorpCategory" )
            .flex-column.allProdItemDetailItem
              span.text-decoration-none.pl-3.mb-2.itemHover(v-for="item1 in totalCorp" v-if="item1.groupcode === item" :key="item1.designerId" :to="'/designer/' + item1.id + '/' + item1.designerId" @click="designer(item1.id,item1.designerId)") - {{item1.designerName}}
        //- label(@click="$router.push('/publicWelfare'); $store.state.sideBarShow = false").item.helpCenter.mb-0.align-items-center 公益專區
        //- 公益專區
        //- <input type="checkbox" id="npo" class="d-none">
        //- label(for="npo" v-if="publicwelfareOpen").navItem.font-weight-bold.align-items-center.mb-0.d-flex 公益專區<i class="fas fa-chevron-down ml-auto"></i><i class="fas fa-chevron-up ml-auto"></i>
    //- .allProdItemBoxDesigner.w-100
          .navItem.font-weight-bold.allProdItem( v-for="(item,idx) in totalPublicWelfareCategory" )
            .flex-column.allProdItemDetailItem
              span.text-decoration-none.pl-3.mb-2.itemHover(v-for="item1 in totalPublicWelfare" v-if="item1.groupcode === item" :key="item1.productId" :to="'/designer/' + item1.id + '/' + item1.designerId" @click="designer(item1.id,item1.designerId)") - {{item1.designerName}}
        //- 活動
        //- <input type="checkbox" id="activity"  class="d-none">
        //- label(for="activity" v-if="activityOpen").navItem.font-weight-bold.align-items-center.mb-0.d-flex.activity 活動<i class="fas fa-chevron-down ml-auto"></i><i class="fas fa-chevron-up ml-auto"></i>
        //- .allProdItemBoxDesigner.w-100
          .navItem.font-weight-bold.allProdItem( v-for="(item,idx) in totalActivityCategory" )
            .flex-column.allProdItemDetailItem
              span.text-decoration-none.pl-3.mb-2.itemHover(v-for="item1 in totalActivity" :key="item1.id" :to="'/activity/' + item1.id" @click="activity(item1.id)") - {{item1.activityName}}
    label(@click="gotoUrl('/serviceContent');").item.helpCenter.mb-0.align-items-center 幫助中心
    //- label(@click="gotoUrl('/dedicatedService');").item.helpCenter.mb-0.align-items-center.dedicatedservice 大量印製/特殊需求
    //- 2021/11/17, jamei, label(@click="$router.push(`/activity/${activityId}`); $store.state.sideBarShow = false" v-if="activityOpen").item.helpCenter.mb-0.align-items-center.activity 抽獎活動
    //- label.mb-0.ml-3(data-toggle="modal" data-target="#loginModal") SSO登入測試
    router-link(to="/aboutYFP").text-dark.item.aboutUs.mb-0.align-items-center.text-decoration-none 關於我們
    label(@click="$router.push('/serviceContent/contactus'); $store.state.sideBarShow = false").item.contactUs.mb-0.align-items-center 聯絡我們

    //- taopix 自動帶字 登入測試中
    //- 登入後
    //- 桌機
    //- label.mb-0.align-items-center.login.h-100.afterLoginBox(v-if="")
    //-   .font-weight-bold.text-decoration-none.justify-content-center.align-items-center.afterLogin
    //-     span.memberCenter 會員中心
    //-     .w-100.afterLoginDropDown.flex-column.align-items-center
    //-       a.font-weight-bold.text-decoration-none.mb-3.itemHover.myAccount(onClick="tpxHighLevelRegisterInitControl(); return false;" id="tpx-register")
    //-       a(@click="$router.push('/invoice'); $store.state.sideBarShow = false").text-decoration-none.itemHover.invoiceSearch 發票查詢
    //- //- 登入前
    //- label.item.register.mb-0.align-items-center(v-else)
    //-   a.font-weight-bold.text-decoration-none(onClick="tpxHighLevelRegisterInitControl(); return false;" id="tpx-register")
    //- label.item.login.mb-0.align-items-center
    //-   a.font-weight-bold.text-decoration-none(id="tpx-signIn" onClick="tpxHighLevelSignInInitControl(); return false;")
    //- label.item.myItem.mb-0.align-items-center.tpx.tpx-accountLinkItem(id="tpx-projectslinkli")
    //-   span(id="tpx-projectslist" onclick="tpxMyProjectsOnClick(); return false;")
    //- div.item.myItem.mb-0.align-items-center.tpx
    //-   .tpx(id="tpx-basketButtonWrapper")
    //-     p.mb-0.tpx.tpx-button.tpx-basketButton(id="tpx-basketlink" onclick="tpxBasketOnClick(); return false;")
    //-       span.tpx.tpx-basketCount(id="tpx-basketButtonCount")

    //- taopix 自動帶字 登入測試中
    //- 登入後
    //- 桌機
    label.mb-0.align-items-center.login.afterLoginBox(v-if="mawebhlbr")
      .font-weight-bold.text-decoration-none.justify-content-center.align-items-center.afterLogin
        span.memberCenter 會員中心
        .w-100.afterLoginDropDown.flex-column.align-items-center
          a.font-weight-bold.text-decoration-none.linkHover.mb-3.myAccount(onClick="tpxHighLevelRegisterInitControl(); return false;" id="tpx-register")
          a(@click="$router.push('/invoice'); $store.state.sideBarShow = false").text-decoration-none.linkHover.font-weight-bold.mb-3.invoiceSearch 發票查詢
          a(@click="$router.push('/invoiceCarrier'); $store.state.sideBarShow = false").text-decoration-none.linkHover.font-weight-bold.mb-3.carrierBelong 會員載具歸戶

    //- 登入前
    label.item.register.mb-0.align-items-center(v-else)
      a.font-weight-bold.text-decoration-none(onClick="tpxHighLevelRegisterInitControl(); return false;" id="tpx-register")

    //- 登入登出Taopix按鈕
    label.item.login.mb-0.align-items-center()
      a.font-weight-bold.text-decoration-none(id="tpx-signIn" @click="signInControl")
    //- 2022/09/05, jamei

    //- 編輯中的作品
    label.item.myItem.mb-0.align-items-center.tpx.tpx-accountLinkItem(id="tpx-projectslinkli")
      span(id="tpx-projectslist" onclick="tpxMyProjectsOnClick(); return false;")
    //- 購物車
    //- div.item.myItem.mb-0.align-items-center.tpx
      //- .yfp(id="yfp-basketButtonWrapper")
        //- p.mb-0.yfp.yfp-button.yfp-basketButton(id="yfp-basketlink" onclick="tpxBasketOnClick(); return false;")
          //- span.yfp.yfp-basketCount(id="yfp-basketButtonCount")
    div.item.myItem.mb-0.align-items-center.tpx
      .tpx(id="tpx-basketButtonWrapper")
        p.mb-0.tpx.tpx-button.tpx-basketButton(id="tpx-basketlink" onclick="tpxBasketOnClick(); return false;")
          span.tpx.tpx-basketCount(id="tpx-basketButtonCount")
          //- 20221123 購物車圖示
  //- <!-- My Projects pop out panel -->
  //- loginmodal
  <div id="tpx-projectlistcontents" class="tpx tpx-projectlist">
      <div id="tpx-projectsItemListContainer" class="tpx tpx-projectlist-items-container">
          <ul id="tpx-projectsItemList" class="tpx tpx-shopping-cart-items"></ul>
          <div id="tpx-projectloadingspinnercontainer" class="tpx tpx-loadingspinnercontainer">
              <span id="tpx-projectloadingspinner" class="tpx tpx-loading-spinner"></span>
          </div>
          <div id="tpx-empty-state">
              <p id="tpx-empty-project-text">You don't have any saved projects.</p>
          </div>
      </div>
      button.btn.btn-secondary(onClick="tpxMyProjectsOnClick()") X
  </div>
  //- Basket pop out panel
  <div id="tpx-shoppingcartcontents" class="tpx tpx-shopping-cart">
    <div class="tpx tpx-shopping-cart-header tpx-clearfix">
        <span id="tpx-basketcountbadgeinner" class="tpx tpx-badge">0</span>
        <a href="#" id="tpx-emptyBasketButton" onClick="tpxHighLevelEmptyBasketControl()" class="tpx tpx-button tpx-emptycartbutton">Empty Basket</a>
    </div>
    <div id="tpx-basketItemListContainer" class="tpx tpx-shopping-cart-items-container">
        <ul id="tpx-basketItemList" class="tpx tpx-shopping-cart-items"></ul>
        <div id="tpx-loadingspinnercontainer" class="tpx tpx-loadingspinnercontainer"></div>
        <div id="tpx-empty-cart">
            <p id="tpx-empty-cart-text">Your basket is currently empty</p>
        </div>
    </div>
    <a href="#" id="tpx-checkoutbutton" onClick="tpxHighLevelCheckoutControl()" class="tpx tpx-button tpx-checkout-button">Checkout</a>
    a(onclick="tpxBasketOnClick()" class="tpx tpx-button tpx-checkout-button bg-secondary mt-1 text-light" id="tpx-checkoutbutton") 關閉
  </div>
</template>

<script>
import loginmodal from './loginmodal'
import { mapState, mapActions } from 'vuex'
// import { useGtm } from 'vue-gtm'
export default {
  components: {
    loginmodal
  },
  props: ['viewportWidth'],
  data () {
    return {
      // sideBarShow: false,
      pJsonResponseObject: {},
      login: null,
      mawebhlbr: null,
      activityId: null,
      styleOpen: null,
      // publicwelfareOpen: null,
      activityOpen: null,
      brandcorpOpen: null,
      shop2Open: null,
      YFP_SHOP: 'shop2',
      fullWidth: document.body.clientWidth,
      imgLogo: ''
    }
  },
  methods: {
    signInControl () {
      let vm = this
      if (vm.mawebhlbr) {
        // 登出
        vm.mawebhlbr = !vm.mawebhlbr
        window.tpxDeleteCookie('mawebhlbr')
        window.tpxDeleteCookie('lname')
        window.tpxDeleteCookie('lpass')
        window.tpxDeleteCookie('laccountcode')
        window.tpxDeleteCookie('autologin')
      } else {
        // 登入
        window.tpxHighLevelSignInInitControl()
      }
    },
    closeSideBar () {
      const showStatus = $('#navbarNav').hasClass('show')
      if (showStatus) {
        $('#navbarNav').removeClass('show')
      }
    },
    ...mapActions([
      'getNavBarList',
      'getBrandList',
      // 'getNPOList',
      'getActivityList',
      'getCorpList',
      'getHomeCategory',
      'getNavBarNewList',
      'getNavBar'
    ]),
    // 在store/index.js
    sideBarShowEvent (status) {
      this.$store.commit('sideBarShowEvent', status)
    },
    productdetail (id) {
      // catch error 判斷是否點到同一頁 true reload
      let categoryId = id
      if (categoryId !== 8 && categoryId !== 0) {
        this.$router.push(`/productDetail/${categoryId}`).catch((err) => {
          if (err.name === 'NavigationDuplicated') window.location.reload()
        })
        this.$store.commit('sideBarShowEvent', false)
      }
    },
    standard (id, shopCode) {
      console.log('[standard] id=' + id + ', shopCode=' + shopCode)
      // catch error 判斷是否點到同一頁 true reload
      // 2022/09/06, jamei
      if (
        shopCode !== null &&
        typeof shopCode !== 'undefined' &&
        shopCode !== ''
      ) {
        this.$router.push(`${shopCode}/standard/${id}`).catch((err) => {
          if (err.name === 'NavigationDuplicated') window.location.reload()
        })
      } else {
        this.$router.push(`/standard/${id}`).catch((err) => {
          if (err.name === 'NavigationDuplicated') window.location.reload()
        })
      }
      this.$store.commit('sideBarShowEvent', false)
      // window.location.reload()
    },
    designer (id, designerId, shopCode) {
      if (
        shopCode !== null &&
        typeof shopCode !== 'undefined' &&
        shopCode !== ''
      ) {
        this.$router
          .push(`${shopCode}/designer/${id}/${designerId}`)
          .catch((err) => {
            if (err.name === 'NavigationDuplicated') window.location.reload()
          })
      } else {
        this.$router.push(`/designer/${id}/${designerId}`).catch((err) => {
          if (err.name === 'NavigationDuplicated') window.location.reload()
        })
      }
      this.$store.commit('sideBarShowEvent', false)
    },
    goProductPage (productId, url, shopCode) {
      if (shopCode === this.YFP_SHOP) {
        this.standard(productId, shopCode)
      } else {
        if (url !== null && url !== '') {
          window.top.location = url
        } else {
          // 2022/09/06, jamei, this.standard(productId)
          this.standard(productId, shopCode)
        }
      }
    },
    goDesignerPage (licensorId, designerId, shopCode) {
      this.designer(licensorId, designerId, shopCode)
    },
    activity (activityId) {
      this.$router.push(`/activity/${activityId}`).catch((err) => {
        if (err.name === 'NavigationDuplicated') window.location.reload()
      })
      this.$store.commit('sideBarShowEvent', false)
    },
    gotoUrl (url) {
      this.$router.push(url).catch((err) => {
        if (err.name === 'NavigationDuplicated') window.location.reload()
      })
      this.$store.state.sideBarShow = false
    }
  },
  computed: {
    ...mapState({
      totalCategory: (state) => state.navbarModules.totalCategory,
      eachCategoryNumber: (state) => state.navbarModules.eachCategoryNumber,
      categoryId: (state) => state.navbarModules.categoryId,
      totalProduct: (state) => state.navbarModules.totalProduct,
      sideBarShow: (state) => state.sideBarShow,
      productEnCategory: (state) => state.navbarModules.productEnCategory,
      eachCategoryProduct: (state) => state.navbarModules.eachCategoryProduct,
      // discount
      discountInfo: (state) => state.navbarModules.discountInfo,
      getIndexData: (state) => state.homeModules.getIndexData,
      // 設計品牌館
      totalDesign: (state) => state.navbarModules.totalDesign,
      totalDesignCategory: (state) => state.navbarModules.totalDesignCategory,
      // 公益專區
      // totalPublicWelfare: (state) => state.navbarModules.totalPublicWelfare,
      // totalPublicWelfareCategory: (state) =>
      //  state.navbarModules.totalPublicWelfareCategory,
      // 活動
      totalActivity: (state) => state.navbarModules.totalActivity,
      totalActivityCategory: (state) =>
        state.navbarModules.totalActivityCategory,
      // 品牌合作
      totalCorp: (state) => state.navbarModules.totalCorp,
      totalCorpCategory: (state) => state.navbarModules.totalCorpCategory,
      getHomeCategoryData: (state) => state.homeModules.getHomeCategoryData,
      navBarList1: (state) => state.navbarNewModules.navBarList1,
      navBarList2: (state) => state.navbarNewModules.navBarList2,
      navBarList3: (state) => state.navbarNewModules.navBarList3
    })
  },
  created () {
    const vm = this
    // 取下拉選單內容
    vm.getNavBarList()
    vm.getBrandList()
    vm.getNavBar()
    // vm.getNPOList()
    vm.getActivityList()
    vm.getCorpList()
    // vm.getNavBarNewList()
    // 活動畫面埋時間判斷id
    let d = Date.now()
    let activityDueDate = window.activity_due_date
    let date = new Date(activityDueDate).getTime()

    if (d < date) {
      vm.activityId = 1
    } else {
      vm.activityId = 2
    }
    // 設計師品牌館是否開啟
    vm.styleOpen = window.style_open
    // 公益專區是否開啟
    // vm.publicwelfareOpen = window.publicwelfare_open
    vm.activityOpen = window.activity_open
    vm.brandcorpOpen = window.brandcorp_open
    vm.shop2Open = window.shop2_open
    // logo圖片位置
    vm.imgLogo = window.imgLogo
  },
  mounted () {
    let vm = this
    let newPromise = new Promise((resolve, reject) => {
      // 傳入 resolve 與 reject，表示資料成功與失敗
      let ran = window.tpxHighLevelBasketInitialise() // 隨機成功或失敗
      if (ran) {
        resolve(ran)
      }
    })
    newPromise.then((data) => {
      if (data === 'finish') {
        let ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i]
          if (c.charAt(0) === ' ') {
            c = c.substring(1, c.length)
          }
          if (c.indexOf('mawebhlbr') < 0) {
            vm.login = false
          } else {
            vm.mawebhlbr = true
            break
          }
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.topNav {
  height: 80px;
  align-items: center;
  background: white;
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: "Noto Serif TC", serif, Apple Color Emoji, Segoe UI Emoji,
    Segoe UI Symbol, Noto Color Emoji;
  .xBox {
    display: none;
  }
}

.logo {
  margin-right: 50px;
  max-width: 220px;
  img {
    width: 100%;
  }
}
@media (max-width: 1275px) {
  label.hamburger {
    display: initial;
    font-size: 1.5rem;
  }
  .topNav {
    // display: none;
    flex-direction: column;
    height: 100vh;
    width: 50vw;
    align-items: flex-start;
    padding: 16px;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    background: white;
    transform: translateX(-75vw);
// 20230106 修改
    &.show {
      //display: flex;
      display: block;
    }
    a.home {
      width: 100%;
      text-align: center;
    }
    img.newItem{
      width: 40px;
    }
    img {
      max-width: 220px;
    }
    .xBox {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      border: 2px solid black;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      right: 10px;
      top: 10px;
    }
    .sideNavHead {
      width: 100%
    }
    .topNavBox {
      width: 100%;

    }
  }
  #tpx-basket-bar {
    font-size: 0.9rem;
    .memberCenter {
      font-size: 0.9rem;
    }
  }
  #tpx-basket-bar .tpx-bar-container {
    width: 75vw;
    overflow: scroll;
    height: 100vh;
    transform: translateX(-75vw);
    &::-webkit-scrollbar {
      display: none;
    }
    &.show {
      transform: translateX(0vw);
      transition: transform 1s;
      z-index: 49;
      padding-bottom: 80px;

    }
  }
  #tpx-basket-bar .darkBg {
    width: 100vw;
    background: rgba(0, 0, 0, 0.4);
    height: 100vh;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 400;
    z-index: 48;
  }
  #tpx-basket-bar .topNavBox {
    width: 100%;
  }
}
// item 設定
.item {
  color: black;
  font-weight: bold;
  margin-right: 1vw;
  // 20231213
  font-size: 0.9rem;
  &.register,
  &.login,
  &.myItem {
    cursor: pointer;
    display: flex;
  }
  &.register {
    margin-left: 5vw;
  }
  &.allProd {
    position: relative;
    cursor: pointer;
    height: 100%;
  }
  &.saledHelp,
  &.aboutUs,
  &.contactUs {
    display: none;
  }
  &.allProd.deskTop {
    display: flex;
  }
  &.helpCenter {
    cursor: pointer;
  }
}
.linkHover{
  cursor: pointer;
}
img.discount{
  position:relative;
  width: 40%;
  top:-20;
}
img.newItem{
  width: 35px;
}
@media (max-width: 1275px) {
  .item.register {
    margin-left: 0;
  }
  .item.allProd {
    height: auto;
  }
  .item {
    margin-right: 0;
    margin-left: 0;
    padding-top: 16px;
    padding-bottom: 16px;
    box-sizing: border-box;
    width: 100%;
    border-bottom: 2px solid hsla(0, 0%, 50.2%, 0.4);
    &.saledHelp,
    &.aboutUs,
    &.contactUs {
      display: flex;
    }
    &.allProd.deskTop {
      display: none;
    }
    &.register,
    &.login,
    &.myItem {
      display: flex;
      //margin-right: 2px;
    }
    &.editingItem{
      margin-right: 2vw;
    }
  }
}
.indexpage {
  margin-right: -2px;
}
//2022/10/03, jamei
.dropDownMenu,
.styleDropDownMenu,
.corpDropDownMenu,
.navDropDownMenu {
  position: absolute;
  top: 100%;
}
.item.allProd:hover {
  .dropDownMenu {
    display: block;
  }
  .styleDropDownMenu {
    display: block;
  }
  //2022/10/03, jamei
  .corpDropDownMenu {
    display: block;
  }
  .navDropDownMenu {
    display: block;
  }
}
// TODO 20221124 下拉選單修改
//2022/08/25, jamei
.dropDownMenu {
  display: none;
  //2022/08/25, jamei, min-width: 41rem;
  // width: 40rem;
  left: calc(100% - 160px);
  box-sizing: border-box;
  top: calc(100% - 2px);
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  color: black;
  /* 2022/08/25, jamei
    &::before{
      display:block;
      content: "";
      width: 20px;
      height: 20px;
      border-bottom: solid 10px #fefefe;
      border-left: solid 10px transparent;
      border-right: solid 10px transparent;
      position: absolute;
      top: -20px;
      left: calc(50% - 90px);
      z-index: 100000;
    }
    &::after{
      display:block;
      content: "";
      width: 20px;
      height: 20px;
      border-bottom: solid 11px rgba(0,0,0,.3);
      border-left: solid 11px transparent;
      border-right: solid 11px transparent;
      position: absolute;
      top: -21px;
      left: calc(50% - 91px);
      z-index: 1;
    }
    */
  .navbarItem{
    width: 10rem;
    padding: 10px;
  }
  .itemHover {
    color: black;
    font-family: "Microsoft JhengHei", "Noto Serif TC", serif, Apple Color Emoji,
      Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  }
  .itemHover:hover {
    //2022/08/25, jamei, color: rgba(0,0,0,.3);
    color: #fff;
    background-color: #5c87a6;
  }
  //2022/09/05, jamei
  .itemHover2 {
    color: black;
    font-family: "Microsoft JhengHei", "Noto Serif TC", serif, Apple Color Emoji,
      Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  }
  .itemHover2:hover {
    color: #fff;
    background-color: #f8c15c;
  }
}
.navDropDownMenu {
  display: none;
  //2022/08/25, jamei, min-width: 41rem;
  width: 11vw;
  padding: 0 10px;
  box-sizing: border-box;
  //2022/08/25, jamei, left: -222px;
  left: -20px;
  top: calc(100% - 2px);
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  color: black;
  .itemHover {
    color: black;
    font-family: "Microsoft JhengHei", "Noto Serif TC", serif, Apple Color Emoji,
      Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  }
  .itemHover:hover {
    //2022/08/25, jamei, color: rgba(0,0,0,.3);
    color: #fff;
    background-color: #5c87a6;
  }
  //2022/09/05, jamei
  .itemHover2 {
    color: black;
    font-family: "Microsoft JhengHei", "Noto Serif TC", serif, Apple Color Emoji,
      Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  }
  .itemHover2:hover {
    color: #fff;
    background-color: #f8c15c;
  }
}

.styleDropDownMenu {
  display: none;
  min-width: 11rem;
  max-width: 42rem;
  padding: 0 16px;
  box-sizing: border-box;
  left: -50%;
  top: calc(100% - 2px);
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  color: black;
  white-space: nowrap;
  /* 2022/08/25, jamei
    &::before{
      display:block;
      content: "";
      width: 20px;
      height: 20px;
      border-bottom: solid 10px #fefefe;
      border-left: solid 10px transparent;
      border-right: solid 10px transparent;
      position: absolute;
      top: -20px;
      left: calc(50% - 11px);
      z-index: 100000;
    }
    &::after{
      display:block;
      content: "";
      width: 20px;
      height: 20px;
      border-bottom: solid 11px rgba(0,0,0,.3);
      border-left: solid 11px transparent;
      border-right: solid 11px transparent;
      position: absolute;
      top: -21px;
      left: calc(50% - 12px);
      z-index: 1;
    }
    */
  .itemHover {
    color: black;
    //2022/08/25, jamei
    font-family: "Microsoft JhengHei", "Noto Serif TC", serif, Apple Color Emoji,
      Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  }
  .itemHover:hover {
    //2022/08/25, jamei, color: rgba(0,0,0,.3);
    color: #fff;
    background-color: #5c87a6;
  }
}
//2022/10/03, jamei
.corpDropDownMenu {
  display: none;
  min-width: 12rem;
  padding: 0 16px;
  box-sizing: border-box;
  left: -50%;
  top: calc(100% - 2px);
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  color: black;
  .itemHover {
    color: black;
    font-family: "Microsoft JhengHei", "Noto Serif TC", serif, Apple Color Emoji,
      Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  }
  .itemHover:hover {
    color: #fff;
    background-color: #5c87a6;
  }
}
// 漢堡選單按鈕
label.hamburger {
  display: none;
  width: 20px;
  height: 0;
  // border-top: 2px solid black;
  //position: relative;
  margin-bottom: 0;
  cursor: pointer;
}
.logoBox {
  display: none;
}
@media (max-width: 1275px) {
  label.hamburger {
    display: initial;
    position: absolute;
    left: 20px;
    //2022/08/17, jamei, top: 35%;
    top: 25%;
    height: 30px;
    margin-top: 0;
  }
  .logoBox {
    display: initial;
    margin-left: 15vw;
    text-align: center;
    width: 100%;
    padding: 16px 0;
    background: white;
    // z-index:98;
    img {
      //2022/08/17, jamei, max-width: 220px;
      max-width: 130px;
    }
  }
  .closeTag {
    text-align: center;
    font-size: 1.5rem;
    cursor: pointer;
    font-weight: 800;
  }
}
// 側邊欄項目樣式
.navItem {
  display: block;
  width: 100%;
  padding: 16px 0;
  border-bottom: 2px solid rgba(128, 128, 128, 0.4);
  box-sizing: border-box;
  span {
    position: relative;
    top: 10px;
  }
}
.navbarListItem {
  display: block;
  width: 100%;
  padding: 8px 0;
  border-top: 1px solid rgba(128, 128, 128, 0.4);
  box-sizing: border-box;
}
.navBarList1Chevron {
  margin-bottom: 10px;
}
.fa-chevron-up {
  display: none;
}
.allProdItemBox,
.allPbItemBox,
.allCardItemBox,
.allBusinessItemBox,
.allFabricsItemBox,
.allGiftItemBox,
.allCupItemBox {
  display: none;
}
// 20221123
.itemHover:hover {
  color: #fff;
  background-color: #5c87a6;
  cursor: pointer;
}
.fz14.text-decoration-none:hover {
  color: #fff;
  background-color: #5c87a6;
  cursor: pointer;
}
.navMobileDetailItem:checked{
  & ~ label {
  & > .fa-chevron-down {
    display: none;
  }
  & > .fa-chevron-up {
    display: block;
    color: rgba(128, 128, 128, 0.4);
  }
  & ~ .allProdItemBox {
    display: block;
    width: 100%;
  }
}
}
#allProd:checked ~ label[for="allProd"] {
  & > .fa-chevron-up {
    display: initial;
    color: rgba(128, 128, 128, 0.4);
  }
  & > .fa-chevron-down {
    display: none;
  }
  & ~ .allProdItemBox {
    display: block;
    width: 100%;
  }
}
#pbNpaint:checked ~ label[for="pbNpaint"] {
  & > .fa-chevron-up {
    display: initial;
    color: rgba(128, 128, 128, 0.4);
  }
  & > .fa-chevron-down {
    display: none;
  }
  & ~ .allPbItemBox {
    display: block;
    width: 100%;
  }
}
#card:checked ~ label[for="card"] {
  & > .fa-chevron-up {
    display: initial;
    color: rgba(128, 128, 128, 0.4);
  }
  & > .fa-chevron-down {
    display: none;
  }
  & ~ .allCardItemBox {
    display: block;
    width: 100%;
  }
}
#business:checked ~ label[for="business"] {
  & > .fa-chevron-up {
    display: initial;
    color: rgba(128, 128, 128, 0.4);
  }
  & > .fa-chevron-down {
    display: none;
  }
  & ~ .allBusinessItemBox {
    display: block;
    width: 100%;
  }
}
#fabrics:checked ~ label[for="fabrics"] {
  & > .fa-chevron-up {
    display: initial;
    color: rgba(128, 128, 128, 0.4);
  }
  & > .fa-chevron-down {
    display: none;
  }
  & ~ .allFabricsItemBox {
    display: block;
    width: 100%;
  }
}
#gift:checked ~ label[for="gift"] {
  & > .fa-chevron-up {
    display: initial;
    color: rgba(128, 128, 128, 0.4);
  }
  & > .fa-chevron-down {
    display: none;
  }
  & ~ .allGiftItemBox {
    display: block;
    width: 100%;
  }
}
#cup:checked ~ label[for="cup"] {
  & > .fa-chevron-up {
    display: initial;
    color: rgba(128, 128, 128, 0.4);
  }
  & > .fa-chevron-down {
    display: none;
  }
  & ~ .allCupItemBox {
    display: block;
    width: 100%;
  }
}
.allProdItemDetailItem {
  display: none;
}
.allProdItemDetail:checked {
  & ~ label {
    color: rgba(128, 128, 128, 0.4);
    & > .fa-chevron-down {
      display: none;
    }
    & > .fa-chevron-up {
      display: block;
    }
  }
  & ~ .allProdItemDetailItem {
    display: block;
  }
}
// 設計師
.allProdItemBoxDesigner {
  display: none;
  .allProdItemDetailItem {
    display: flex;
  }
}

#designer:checked ~ label[for="designer"] {
  & > .fa-chevron-up {
    display: initial;
    color: rgba(128, 128, 128, 0.4);
  }
  & > .fa-chevron-down {
    display: none;
  }
  & ~ .allProdItemBoxDesigner {
    display: block;
    width: 100%;
  }
}
// 公益專區
#npo:checked ~ label[for="npo"] {
  & > .fa-chevron-up {
    display: initial;
    color: rgba(128, 128, 128, 0.4);
  }
  & > .fa-chevron-down {
    display: none;
  }
  & ~ .allProdItemBoxDesigner {
    display: block;
    width: 100%;
  }
}
// 活動
#activity:checked ~ label[for="activity"] {
  & > .fa-chevron-up {
    display: initial;
    color: rgba(128, 128, 128, 0.4);
  }
  & > .fa-chevron-down {
    display: none;
  }
  & ~ .allProdItemBoxDesigner {
    display: block;
    width: 100%;
  }
}
//品牌合作
#corp:checked ~ label[for="corp"] {
  & > .fa-chevron-up {
    display: initial;
    color: rgba(128, 128, 128, 0.4);
  }
  & > .fa-chevron-down {
    display: none;
  }
  & ~ .allProdItemBoxDesigner {
    display: block;
    width: 100%;
  }
}
// sidebarbox
@media (max-width: 1275px) {
  .sidebarBox {
    img{
      width: 15%;
      height: 15%;
      border: none;
      margin-top: -10px;
    }
}
}
@media (min-width: 1275px) {
  .sidebarBox {
    display: none;
  }
}
// 活動
.activity {
  color: #f24f55;
}

// 登入後的下拉
@media (max-width: 1275px) {
  .afterLogin {
    .memberCenter {
      display: none;
    }
  }
  .afterLoginBox {
    margin-left: 0;
    padding-top: 16px;
    padding-bottom: 16px;
    box-sizing: border-box;
    width: 100%;
    border-bottom: 2px solid hsla(0, 0%, 50.2%, 0.4);
    justify-content: flex-start;
  }
}

@media (max-width: 1275px) {
  .afterLoginDropDown {
    display: block;
    a {
      display: block;
      color: black;
    }
    .myAccount {
      padding-bottom: 16px;
      border-bottom: 2px solid hsla(0, 0%, 50.2%, 0.4);
    }
    .invoiceSearch {
      margin-top: 16px;
    }
  }
  .categoryCaption {
    border-bottom: none;
  }
}
@media (min-width: 1275px) {
  .afterLogin {
    min-width: 130px;
    position: relative;
    display: flex;
    height: 100%;
    cursor: pointer;
    &:hover {
      .afterLoginDropDown {
        display: flex;
        padding: 10px;
      }
    }
    .categoryCaption {
      border-bottom: none;
    }
  }
  .afterLoginBox {
    display: flex;
    margin-left: 5vw;
    justify-content: center;
  }
  .afterLoginDropDown {
    display: none;
    position: absolute;
    left: 0;
    background: white;
    top: 2.5em;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
    .itemHover {
      color: #5c87a6;
      background-color: #fff;
      cursor: pointer;
    }
    //.itemHover:hover {
    // color: rgba(0, 0, 0, 0.3);
    //}
    &::before {
      display: block;
      content: "";
      width: 20px;
      height: 20px;
      border-bottom: solid 10px #fefefe;
      border-left: solid 10px transparent;
      border-right: solid 10px transparent;
      position: absolute;
      top: -20px;
      left: calc(50% - 10px);
      z-index: 100000;
    }
    &::after {
      display: block;
      content: "";
      width: 20px;
      height: 20px;
      border-bottom: solid 11px rgba(0, 0, 0, 0.3);
      border-left: solid 11px transparent;
      border-right: solid 11px transparent;
      position: absolute;
      top: -21px;
      left: calc(50% - 11px);
      z-index: 1;
    }
  }
}

//2022/08/17, jamei
.item.register.mobile,
.item.myItem.mobile {
  font-size: 0.8rem;
  width: 12vw;
  border-bottom: 0px solid rgba(128, 128, 128, 0.4);
}

@media (max-width: 1275px) {
  .item.register.mobile,
.item.myItem.mobile {
  display: block;
  width: 15vw;
}
.logoBox{
  margin-left: 15vw;
}
}
@media (max-width: 1275px) {
  .item.register.mobile,
.item.myItem.mobile {
  width: 20vw;
}
}
@media (max-width: 780px) {
.item.register.mobile,
.item.myItem.mobile {
  width: 20vw;
}
.logoBox{
  margin-left: 12vw;
}
.editingItem{
  margin-right: 0;
}
}
//2022/08/25, jamei
.dedicatedservice::after {
  font-family: "Font Awesome 5 Free";
  font-weight: 300;
  content: "\f3a5";
  vertical-align: super !important;
  font-size: 90% !important;
  line-height: 0 !important;
  color: gold;
}
.mobileNavItem a {
  display: inline-block !important;
  text-decoration: none !important;
  color: black !important;
  cursor: default;
}
.mobileNavItem a:hover {
  display: inline-block !important;
  text-decoration: none !important;
  color: black !important;
  cursor: default;
}
// 天選單字體大小
.categoryCaption {
  font-size: 1rem;
  border-bottom: 1.5px #5c87a6 solid;
}

.categoryCaption2 {
  font-size: 1rem;
  border-bottom: 1.5px #5c87a6 solid;
}
.corpCaption {
  font-size: 0.9rem;
}
@media (max-width: 1780px) {

  .item{
    font-size: 0.9rem;
  }
  .categoryCaption {
    font-size: 0.9rem;
  }
  .corpCaption {
    font-size: 0.9rem;
  }
  #tpx-basket-bar {
    font-size: 0.9rem;
  }
  .logo{
    margin-right: 40px;
    max-width: 190px;
  }
  .dropDownMenu{
    .navbarItem{
      width: 10rem;
    }
  }
}
@media (max-width: 1680px) {

  .item{
    font-size: 0.8rem;
  }
  .categoryCaption {
    font-size: 0.8rem;
  }
  .corpCaption {
    font-size: 0.8rem;
  }
  #tpx-basket-bar {
    font-size: 0.8rem;
  }
  .logo{
    max-width: 180px;
  }
  .dropDownMenu{
    .navbarItem{
      width: 9rem;
    }
  }
}

@media (max-width: 1580px) {

  .navDropDownMenu {
    width: 12vw;
    left: -10px;
  }
  .item{
    font-size: 0.8rem;
  }
  .categoryCaption {
    font-size: 0.8rem;
  }
  .corpCaption {
    font-size: 0.8rem;
  }
  #tpx-basket-bar {
    font-size: 0.8rem;
  }
  .logo{
    margin-right: 30px;
    max-width: 170px;
  }
  .dropDownMenu{
    .navbarItem{
      width: 8.5rem;
    }
  }
}
@media (max-width: 1396px) {

  .navDropDownMenu {
    width: 13vw;
  }
  .item{
    font-size: 0.8rem;
  }
  .categoryCaption {
    font-size: 0.8rem;
  }
  .corpCaption {
    font-size: 0.8rem;
  }
  #tpx-basket-bar {
    font-size: 0.8rem;
  }
  .logo{
    margin-right: 20px;
    max-width: 150px;
  }
  .dropDownMenu{
    .navbarItem{
      width: 8.5rem;
    }
  }
}
@media (max-width: 1275px) {
  .item{
    font-size: 0.8rem;
  }
  .categoryCaption {
    font-size: 0.8rem;
  }
  .corpCaption {
    font-size: 0.8rem;
  }
  #tpx-basket-bar {
    font-size: 0.8rem;
  }
  #tpx-basket-bar-inner {
    font-size: 1rem;
    .item{
      font-size: 1rem;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/combineNav2.vue